export default "__VITE_ASSET__MGN504vS__"